import React, { useEffect, useState } from 'react';
import './NetworkStatus.css';

const ARC_TESTNET = {
  chainIdDecimal: 5042002,
  rpcUrl: 'https://rpc.testnet.arc.network'
};

function NetworkStatus() {
  const [block, setBlock] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const res = await fetch(ARC_TESTNET.rpcUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ jsonrpc: '2.0', id: 1, method: 'eth_blockNumber', params: [] })
        });
        const data = await res.json();
        const n = parseInt(data.result, 16);
        if (!cancelled && Number.isFinite(n)) setBlock(n);
      } catch {
        if (!cancelled) setBlock(null);
      }
    };
    tick();
    const id = setInterval(tick, 8000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return (
    <div className="network-status" title={`Arc Testnet · chain ${ARC_TESTNET.chainIdDecimal}`}>
      <span className="network-status__pulse" />
      <span className="network-status__text">
        powered by arc · testnet · chain {ARC_TESTNET.chainIdDecimal} · block {block !== null ? block.toLocaleString() : '—'}
      </span>
    </div>
  );
}

export default NetworkStatus;
